import {
  GET_ORDER_DETAIL_DATA,
  GET_ORDER_TABLE_DATA,
  SELECT_ORDER,
  SET_ORDER_DETAIL_STATUS,
  SET_ORDER_TABLE_STATUS,
} from '../helpers/types';

const INITIAL_STATE = {
  ordersDataArr: [],
  isLoading: false,
  orderData: {},
  top: 20,
  listCount: null,
  selOrderDetailData: null,
  isOrderDetailLoading: false,
  failText: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_ORDER_TABLE_DATA:
      return {
        ...state,
        ordersDataArr: action.payload.data,
        isLoading: false,
        listCount: action.payload.listCount,
      };
    case GET_ORDER_DETAIL_DATA:
      return {
        ...state,
        selOrderDetailData: action.payload.selOrderDetailData,
        isOrderDetailLoading: false,
      };
    case SET_ORDER_DETAIL_STATUS:
      return {
        ...state,
        isOrderDetailLoading: action.payload.isOrderDetailLoading,
      };
    case SELECT_ORDER:
      return { ...state, orderData: action.payload };
    case SET_ORDER_TABLE_STATUS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
